import {axios as http} from "@/plugins/http"

export default class Api {
    static tags() {
        return http.post("/api/v1/post/tags").then((resp) => {
            return resp.data["items"]
        })
    }
}
